import { useTranslation } from "react-i18next";

import { DashboardPage } from "@/components/dashboard/DashboardPage";
import { AppHead } from "@/components/shared/head/AppHead";
import { RouteConfig } from "@/config/route.config";
import { AuthGuard } from "@/data/auth/AuthGuard";

export default function HomePage() {
  const { t } = useTranslation();

  return (
    <AuthGuard
      type="private"
      redirectTo={RouteConfig.signin}
    >
      <AppHead title={t("watchlist.head.title")} />
      <DashboardPage />
    </AuthGuard>
  );
}
